import { Icon } from '#/components/Icon/Icon';
import type { CmsApiS3FileLink } from '#/modules/cms/api/types/CmsApiLink';
import { useCmsDownloadPermissions } from '#/modules/cms/hooks/useCmsDownloadPermissions';

import type { CmsButtonRender } from './types/CmsButtonRender';

type Props = {
  buttonData: CmsApiS3FileLink;
  eventProperties: Record<string, unknown>;
  render: CmsButtonRender;
};

export function CmsDownloadButton({
  buttonData,
  eventProperties,
  render,
}: Props) {
  const { onClick, href, download } = useCmsDownloadPermissions({
    buttonData,
    eventName: 'CMS Block',
    eventProperties,
  });

  return render({
    data: href
      ? { type: 'link', anchorType: 'native', onClick, href }
      : { type: 'button', onClick },
    children: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {download && <Icon name="download" size={18} />}
        <div style={{ marginLeft: '8px' }}>
          {download ? `  ${buttonData.text}` : buttonData.text}
        </div>
      </div>
    ),

    qaId: 'cms-download-button-link',
  });
}
